<app-spinner [loading]="spinnerService.loading$ | async" id="spinner" />
<div id="flip-history-screen">
  <app-header-bar
    (routerLinkClick)="routerLinkClicked()"
    *ngIf="_dob != undefined || _dob != null"
    [age]="_age"
    [dob]="_dob"
    [showButton]="false"
    [showClientDetails]="false"
    [title]="_title"
  />
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      id="client-information"
      subtitle=""
    />
  </div>
  <!-- Sub-Menu -->
  <app-sub-menu
    (navigateBackClick)="previousRoute()"
    [clientId]="_clientId"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [showBackButton]="true"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [totalReviews]="_totalReviews"
  />
  <div id="latest-assessment-container">
    <app-primary-card
      id="assessment-card"
      paddingSize="large"
      [size]="_assessmentPanelSize"
    >
      <div id="assessment-header">
        <div id="logo">
          <app-flip-logo />
        </div>
        <div
          *ngIf="!(spinnerService.loading$ | async)"
          class="grey-text"
          id="last-assessment-information"
        >
          <span *ngIf="_lastAssessmentDateUnavailable">No data available</span>
          <span *ngIf="!_lastAssessmentDateUnavailable"
            >Last assessment {{ _lastAssessmentDateAgo }} ago,
            {{ _lastAssessmentDate }}</span
          >
        </div>
      </div>
      <div id="assessment">
        <app-collapsible [items]="_collapsibleItems" />
      </div>
    </app-primary-card>
    <div id="side-cards">
      <div id="button-card-container">
        <app-side-card id="button-card" [size]="_graphPanelSize">
          <div id="button-card-title">
            {{ 'Add todays entry' | translate }}
            <span class="grey-text">({{ _todaysDateFormatted }})</span>
          </div>
          <div id="button-row">
            <div id="add-entry-button-container">
              <app-action-button
                (onClick)="NavigateToFlipAssessment()"
                color="primary"
                id="add-entry-button"
                kind="filled"
                size="extra-wide"
                >{{ 'Add a new entry' | translate }}
              </app-action-button>
            </div>
            <div id="no-change-button-container">
              <app-action-button
                (onClick)="SubmitExistingAssessment()"
                color="primary"
                id="no-change-button"
                kind="outline"
                size="extra-wide"
                >{{ 'No change, submit entry' | translate }}
              </app-action-button>
            </div>
          </div>
        </app-side-card>
      </div>
      <div id="graph-card-container">
        <app-side-card id="graph-card" [size]="_graphPanelSize">
          <app-flip-dashboard-graph
            [clientId]="_clientId"
          ></app-flip-dashboard-graph>
          <div id="full-page-link">
            <div>
              <app-link [color]="'grey'" [destination]="_createFlipReportLink">
                Create FLI-P report
              </app-link>
            </div>
            <div>
              <app-link
                [destination]="_fullPageReportLink"
                color="accent"
                kind="standard"
                >View full page FLI-P visualisation
              </app-link>
            </div>
          </div>
        </app-side-card>
      </div>
    </div>
  </div>
  <div id="table-container">
    <app-primary-card
      height="741"
      paddingSize="large"
      [size]="_overviewPanelSize"
      title="FLI-P Overview"
    >
      <app-table
        [columnDefinitions]="_tableColumnDefinitions"
        [columnsToDisplay]="_tableColumnsToDisplay"
        [dataSource]="_tableData"
        id="history-table"
        kind="styled-header"
        pageSize="12"
        showPager="true"
      />
    </app-primary-card>
  </div>
</div>
